import { Component } from '@angular/core';
import { NavParams, NavController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { EventStreaming } from '../../pages/event-streaming/event-streaming';

@Component({
  selector: 'event-streaming',
  templateUrl: 'event-streaming.html'
})
export class EventStreamingComponent {

  obsEmbed: any;
  obsListener: any;
  event: any;
  client: string;
  componentState: boolean = false;
  dataStreaming: any = false;

  constructor(public eventProvider: EventData, public params: NavParams, public navCtrl: NavController, events: Events) {
    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'streaming').subscribe(stateModule => {

      if (stateModule.$value === true) {
        this.obsEmbed = this.eventProvider.getStreaming(this.client, this.event.id).subscribe((data) => {
          this.dataStreaming = data;

          this.componentState = true;
        });
      } else {
        this.dataStreaming = false;
        this.componentState = false;
        console.log("Módulo Streaming deshabilitado");
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  view() {
    this.navCtrl.push(EventStreaming, {client: this.client, event: this.event, dataStreaming: this.dataStreaming});
  }

  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de Streaming');
      this.obsListener.unsubscribe();
    }
    if (this.obsEmbed) {
      this.obsEmbed.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-streaming/event-streaming.ts